const mixin = {
  data () {
    return {
      sw_registration: null,
      updateExists: false,
      refreshing: false
    }
  },


  created  () {
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      window.location.reload()
    })
  },


  methods: {
    updateAvailable (event) {
      this.sw_registration = event.detail
      this.updateExists = true
    },

    refreshApp () {
      this.updateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.sw_registration || !this.sw_registration.waiting) return
      // Send message to SW to skip the waiting and activate the new SW
      this.sw_registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  }
}

export default mixin
